import {Inject, Injectable, Optional} from '@angular/core';
import {LogPublisher} from './log-publishers';
import {LogPublishersService} from './log-publishers.service';
import {LogEntry, LogLevel} from './log-entry';

@Injectable()
export class LogService {
  level: LogLevel = LogLevel.All;
  logWithDate = true;
  publishers: LogPublisher[];

  constructor(private publishersService: LogPublishersService, @Inject('logLevel') @Optional() level: LogLevel) {
    if (level !== null) {
      this.level = level;
    }
    // Set publishers
    this.publishers =
      this.publishersService.publishers;
  }

  debug(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Debug,
      optionalParams);
  }

  info(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Info,
      optionalParams);
  }

  warn(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Warn,
      optionalParams);
  }

  error(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Error,
      optionalParams);
  }

  fatal(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Fatal,
      optionalParams);
  }

  consoleLog(msg: string, ...optionalParams: any[]) {
    if (this.level <= LogLevel.Info) {
      console.log(msg, optionalParams);
    }
    this.info(msg, optionalParams);
  }

  consoleWarn(msg: string, ...optionalParams: any[]) {
    if (this.level <= LogLevel.Warn) {
      console.warn(msg, optionalParams);
    }
    this.warn(msg, optionalParams);
  }

  consoleError(msg: string, ...optionalParams: any[]) {
    if (this.level <= LogLevel.Fatal) {
      console.error(msg, optionalParams);
    }
    this.fatal(msg, optionalParams);
  }


  private writeToLog(msg: string, level: LogLevel, params: any[]) {
    if (this.shouldLog(level)) {
      const entry: LogEntry = new LogEntry();
      entry.message = msg;
      entry.level = level;
      entry.extraInfo = params;
      entry.logWithDate = this.logWithDate;
      // Log the value
      for (const logger of this.publishers) {
        logger.log(entry)
          .subscribe(response => {
          });
      }
    }
  }

  private shouldLog(level: LogLevel): boolean {
    let ret = false;
    if ((level >= this.level &&
      this.level !== LogLevel.Off) ||
      this.level === LogLevel.All) {
      ret = true;
    }
    return ret;
  }

  private formatParams(params: any[]): string {
    let ret: string = params.join(',');
    // Is there at least one object in the array?
    if (params.some(p => typeof p === 'object')) {
      ret = '';
      // Build comma-delimited string
      for (const item of params) {
        ret += JSON.stringify(item) + ',';
      }
    }
    return ret;
  }
}
